import TimeCardExpenseList from 'pages/timecards/expenses/TimeCardExpenseList';
import { Controller } from 'react-hook-form';
import { TimecardFormState } from './useTimecardForm';

/** The expenses staged on the timecard, saved with it. */
export const ExpensesFields = ({ form }: { form: TimecardFormState }): JSX.Element => {
    const { control } = form.methods;
    const {
        params: { id },
        currentMatter,
        classifiers,
        initialFormData,
    } = form;

    return (
        <Controller
            control={control}
            name="expenses"
            render={({ field }) => (
                <TimeCardExpenseList
                    timecardData={{
                        id: id ? parseInt(id) : undefined,
                        matterId: currentMatter?.id,
                    }}
                    classifiers={classifiers}
                    expenses={initialFormData?.expenses ?? []}
                    onChange={field.onChange}
                />
            )}
        />
    );
};
